import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type VersionResponse = {
  environment: string
  servicesTimeStamp: string
  version: string
  commitHash?: string
  commitDate?: string
}

export function useGetVersion() {
  return useQuery({
    queryKey: ['app-version'],
    queryFn: async () => (await apiClient.get<VersionResponse>(`/int/version`)).data,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
